import { render, staticRenderFns } from "./Nnacres.vue?vue&type=template&id=791d717e&scoped=true"
import script from "./Nnacres.vue?vue&type=script&lang=js"
export * from "./Nnacres.vue?vue&type=script&lang=js"
import style0 from "./Nnacres.vue?vue&type=style&index=0&id=791d717e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "791d717e",
  null
  
)

export default component.exports